"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function extract(props, prop) {
    var _a;
    if (typeof prop === 'string') {
        if (props.hasOwnProperty(prop)) {
            return _a = {}, _a[prop] = props[prop], _a;
        }
    }
    else {
        var res_1 = {};
        prop.forEach(function (key) {
            if (props.hasOwnProperty(key)) {
                res_1[key] = props[key];
            }
        });
        return res_1;
    }
}
exports.extract = extract;
var parser = new DOMParser();
function htmlToVdom(html) {
    if (!html)
        return null;
    return processNode(parser.parseFromString("<div>" + html + "</div>", "text/xml").childNodes[0]).children;
}
exports.htmlToVdom = htmlToVdom;
function processNode(node) {
    if (node.nodeType === 1) {
        var i, child, attributes = {}, children = [];
        for (i = 0; (child = node.attributes[i]); ++i) {
            attributes[child.nodeName] = child.nodeValue;
        }
        for (i = 0; (child = node.childNodes[i]); ++i) {
            var vn = processNode(child);
            if (vn !== null)
                children.push(vn);
        }
        return {
            nodeName: node.tagName,
            attributes: attributes,
            children: children
        };
    }
    if (node.nodeType === 3) {
        var v = node.nodeValue.trim();
        if (v !== '') {
            return v;
        }
        return null;
    }
}
